import './BackButton.css'

function BackButton({ onClick, label = 'Tilbage', className = '' }) {
  return (
    <button
      type="button"
      className={['back-button', className].filter(Boolean).join(' ')}
      onClick={onClick}
      aria-label={label}
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M14.5 6.25 8.25 12l6.25 5.75"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  )
}

export default BackButton
